import './SectionHeader.css';
import ActionButton from '../ActionButton/ActionButton';
import GradientText from '../GradientText/GradientText';

export default function SectionHeader({
  gradientText,
  title,
  button,
  onButtonClick,
}) {
  const actionContent = typeof button === 'string'
    ? (
      <ActionButton label={button} onClick={onButtonClick} />
    )
    : button;

  return (
    <div className="SectionHeader">
      {gradientText ? (
        <GradientText className="SectionHeader__year" text={gradientText} />
      ) : null}
      <div className="SectionHeader__titleRow">
        <div className="SectionHeader__titleGroup">
          <span className="SectionHeader__dot GradientDot" aria-hidden="true" />
          <h2 className="SectionHeader__title">{title}</h2>
        </div>
        {actionContent ? (
          <div className="SectionHeader__action">{actionContent}</div>
        ) : null}
      </div>
    </div>
  );
}
